import { useData } from '../context/DataContext'

export function useIoBroker() {
  const { iobroker: data, iobrokerLoading: loading, iobrokerError: error, lastUpdated } = useData()
  return { data, loading, error, lastUpdated }
}
